import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore('properties-informations', storeModule.createStoreModule('properties-informations'))
